export const validateZipCode = (number) => {
    const patternZipCode = /^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/;

    if (patternZipCode.test(number)) {
        return true;
    }
    return false;
};
